import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ConsultationListState {
  consultationList: any[];
  selectedConsultation: any | null;
  isLoading: boolean;
  error: string | null;
}

const initialState: ConsultationListState = {
  consultationList: [],
  selectedConsultation: null,
  isLoading: false,
  error: null,
};

const consultationListSlice = createSlice({
  name: 'consultationList',
  initialState,
  reducers: {
    setConsultationList: (state, action: PayloadAction<any[]>) => {
      state.consultationList = action.payload;
      state.error = null;
    },
    setSelectedConsultation: (state, action: PayloadAction<any>) => {
      state.selectedConsultation = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
    clearConsultationList: (state) => {
      state.consultationList = [];
      state.selectedConsultation = null;
      state.error = null;
    },
  },
});

export const {
  setConsultationList,
  setSelectedConsultation,
  setLoading,
  setError,
  clearConsultationList,
} = consultationListSlice.actions;

export default consultationListSlice.reducer; 